export function Deny() {
  return <></>
}
